module.exports = __webpack_public_path__ + "assets/locations/Dragon Bones/bg.jpg";